import React, { useEffect, useState } from 'react';
import { useSpring, animated } from '@react-spring/web';
import '../css/FireWorks.css'; // Import du CSS

const COLORS = ['#6F3F89', '#375A9C', '#029FB2', '#29A648', '#E0B614', '#DA5E20', '#C11D24'];

const FireWorks = () => {
  const [fireworks, setFireworks] = useState([]);

  const generateFirework = () => {
    const color = COLORS[Math.floor(Math.random() * COLORS.length)];
    const startX = Math.random() * window.innerWidth; // Position horizontale aléatoire
    const height = Math.random() * 200 + 300; // Hauteur d'explosion aléatoire

    const key = Date.now() + Math.random();
    setFireworks((prev) => [...prev, { key, startX, height, color }]);

    // Nettoyer après explosion
    setTimeout(() => {
      setFireworks((prev) => prev.filter((f) => f.key !== key));
    }, 5000);
  };

  useEffect(() => {
    const interval = setInterval(generateFirework, 2000); // Générer un feu toutes les 2 secondes
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fireworks-container">
      {fireworks.map(({ key, ...props }) => (
        <Firework key={key} {...props} />
      ))}
    </div>
  );
};

const Firework = ({ startX, height, color }) => {
  const [exploded, setExploded] = useState(false);

  // Animation pour faire monter le feu d'artifice
  const launchStyle = useSpring({
    from: { transform: `translate(${startX}px, 100vh)`, opacity: 1 },
    to: { transform: `translate(${startX}px, ${window.innerHeight - height}px)`, opacity: 1 },
    config: { tension: 150, friction: 20 },
    onRest: () => setExploded(true), // Passer à l'explosion après la montée
  });

  return (
    <>
      {!exploded && (
        <animated.div
          className="firework-launch"
          style={{
            ...launchStyle,
            '--firework-color': color,
          }}
        />
      )}
      {exploded && <Explosion x={startX} y={window.innerHeight - height} color={color} />}
    </>
  );
};

const Explosion = ({ x, y, color }) => {
  const particles = Array.from({ length: Math.floor(Math.random() * 20 + 10) }).map(() => {
    const angle = Math.random() * 2 * Math.PI; // Angle aléatoire en radians
    return {
      angle,
      speed: 150, // Vitesse uniforme pour toutes les particules
      size: Math.random() * 5 + 5, // Taille aléatoire des particules
    };
  });

  return particles.map((particle, index) => (
    <Particle
      key={index}
      x={x}
      y={y}
      angle={particle.angle}
      speed={particle.speed}
      size={particle.size}
      color={color}
    />
  ));
};

const Particle = ({ x, y, angle, speed, size, color }) => {
  const [position, setPosition] = useState({ dx: 0, dy: 0 }); // Position actuelle
  const [gravity, setGravity] = useState(0); // Gravité agissant sur la particule

  useEffect(() => {
    const interval = setInterval(() => {
      setGravity((prev) => prev + 0.5); // Augmenter la gravité progressivement
      setPosition((prev) => ({
        dx: prev.dx + Math.cos(angle) * speed * 0.05, // Déplacement horizontal
        dy: prev.dy + Math.sin(angle) * speed * 0.05 + gravity, // Déplacement vertical avec gravité
      }));
    }, 50);

    return () => clearInterval(interval);
  }, [angle, speed, gravity]);

  return (
    <animated.div
      className="firework-particle"
      style={{
        left: x + position.dx,
        top: y + position.dy,
        '--particle-color': color,
        width: size,
        height: size,
        opacity: Math.max(1 - gravity / 20, 0), // Réduire l'opacité au fil du temps
      }}
    />
  );
};

export default FireWorks;
